import { PLATE_NAME } from 'src/constants/forms';

export default class Plate {
  static NAME = 'plate';

  static getDetailsConfig(payload) {
    const { plateName } = payload;

    return {
      url: `/v2/oligos/plates/${plateName}`,
    };
  }

  static getPutConfig(payload) {
    const { oldPlateName } = payload;

    return {
      url: `/v2/oligos/plates/${oldPlateName}/name`,
    };
  }

  // used to calculate summary on refresh
  static getCreateConfig() {
    return {
      url: '/v2/oligos/plates/platesSummary',
    };
  }

  static getDeleteConfig(payload) {
    const { plateName } = payload;

    return {
      url: `/v2/oligos/plates/${plateName}`,
    };
  }

  static isDataValid(data = {}) {
    return !!data[PLATE_NAME]?.value && data[PLATE_NAME]?.isValid;
  }

  static processApiData(data = {}) {
    return {
      newPlateName: data[PLATE_NAME]?.value,
    };
  }

  constructor(plate = {}) {
    this.plateName = plate.plateName;
    this.plateWells = plate.plateWells;
  }
}
